import '../css/chart_div.css';
function chart_div({children}) {

  return (
    <div className="chart_div">
      {children}
    </div>
  );
}

export default chart_div;